import SiteLink from 'components/shared/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import UpsellSlider from '../upsellSlider';
import styles from './ctaSlot.module.scss';

const CtaSlot = ({
  isEmpty,
  giftChoiceAvailable,
  onOpenGiftChoice,
  upsellItems,
  translations,
  links,
  locale,
  onClose,
}) => {
  const router = useRouter();

  if (giftChoiceAvailable) {
    return (
      <div className={styles.slot}>
        <button type="button" className={styles.outlinedCta} onClick={onOpenGiftChoice}>
          {translations?.freeItem?.buttonText}
        </button>
      </div>
    );
  }

  const emptyCta = links?.linkEmptyCartCta;
  if (isEmpty && emptyCta?.slug) {
    return (
      <div className={styles.slot}>
        <SiteLink
          locale={locale}
          href={addLocaleToHref(emptyCta.slug, locale, router)}
          onClick={onClose}
        >
          <button type="button" className={styles.outlinedCta}>
            {emptyCta.title}
          </button>
        </SiteLink>
      </div>
    );
  }

  // Cart has items and no gift choice pending → upsell slider (renders nothing
  // when there are no recommendations, per client: empty = no slider). Wrapper
  // full-bleeds the grey strip across the scroll body's horizontal padding.
  return (
    <div className={styles.upsellSlot}>
      <UpsellSlider items={upsellItems} locale={locale} />
    </div>
  );
};

export default CtaSlot;
